<template>
  <b-row style="width:100%">
    <b-col>
      <b-row v-if="listingLoaded">
        <b-col>
          <b-row style="padding-left: 15px;">
            <b-col>
              <b-row class="custom" v-if="notEmpty(listing.techDet.buildingYear)">
                <b-col>
                  <span class="align-middle propertyKey">{{i18n_local.building_year}}</span>
                </b-col>
                <b-col class="text-right">
                  <span class="align-middle">{{listing.techDet.buildingYear|capitalize}}</span>
                </b-col>
              </b-row>
              <b-row class="custom" v-if="notEmpty(listing.techDet.generalArea)">
                <b-col>
                  <span class="align-middle propertyKey">{{i18n_local.general_area}}</span>
                </b-col>
                <b-col class="text-right">
                  <span class="align-middle">{{listing.techDet.generalArea|capitalize}} m2</span>
                </b-col>
              </b-row>
              <b-row class="custom" v-if="notEmpty(listing.techDet.livingArea)">
                <b-col>
                  <span class="align-middle propertyKey">{{i18n_local.living_area}}</span>
                </b-col>
                <b-col class="text-right">
                  <span class="align-middle">{{listing.techDet.livingArea|capitalize}} m2</span>
                </b-col>
              </b-row>
              <b-row class="custom" v-if="notEmpty(listing.techDet.heatedArea)">
                <b-col>
                  <span class="align-middle propertyKey">{{i18n_local.heated_area}}</span>
                </b-col>
                <b-col class="text-right">
                  <span class="align-middle">{{listing.techDet.heatedArea|capitalize}} m2</span>
                </b-col>
              </b-row>
              <b-row class="custom">
                <b-col>
                  <span class="align-middle propertyKey">{{i18n_local.fools_explicit}}</span>
                </b-col>
                <b-col class="text-right">
                  <span
                    class="align-middle"
                  >{{listing.techDet.entryFloor}} / {{listing.techDet.buildingNrOfFloor}}</span>
                </b-col>
              </b-row>
              <b-row class="custom">
                <b-col>
                  <span class="align-middle propertyKey">{{i18n_local.condition}}</span>
                </b-col>
                <b-col class="text-right">
                  <span class="align-middle">{{listing.techDet.condition|capitalize}}</span>
                </b-col>
              </b-row>
              <b-row class="custom">
                <b-col>
                  <span class="align-middle propertyKey">{{i18n_local.property_type}}</span>
                </b-col>
                <b-col class="text-right">
                  <span class="align-middle">{{listing.genDet.propType.superType|capitalize}}</span>
                </b-col>
              </b-row>
              <b-row class="custom" v-if="notEmpty(listing.techDet.buildingMat)">
                <b-col>
                  <span class="align-middle propertyKey">{{i18n_local.building_material}}</span>
                </b-col>
                <b-col class="text-right">
                  <span class="align-middle">{{listing.techDet.buildingMat|capitalize}}</span>
                </b-col>
              </b-row>
              <b-row class="custom" v-if="notEmpty(listing.techDet.buildingRoofType)">
                <b-col>
                  <span class="align-middle propertyKey">{{i18n_local.roof_material}}</span>
                </b-col>
                <b-col class="text-right">
                  <span class="align-middle">{{listing.techDet.buildingRoofType|capitalize}}</span>
                </b-col>
              </b-row>
              <b-row class="custom" v-if="notEmpty(listing.techDet.buildingEnLable)">
                <b-col>
                  <span class="align-middle propertyKey">{{i18n_local.energy_label}}</span>
                </b-col>
                <b-col class="text-right">
                  <span class="align-middle">{{listing.techDet.buildingEnLable|capitalize}}</span>
                </b-col>
              </b-row>
              <b-row class="custom" v-if="notEmpty(listing.techDet.parking.placement)">
                <b-col>
                  <span class="align-middle propertyKey">{{i18n_local.parking}}</span>
                </b-col>
                <b-col class="text-right">
                  <span class="align-middle">{{listing.techDet.parking.placement|capitalize}}</span>
                </b-col>
              </b-row>
            </b-col>
          </b-row>

          <!-- HEATINGS -->
          <b-row class="mt-4" v-if="notEmpty(listing.techDet.heatings)">
            <b-col>
              <span
                style="font-size: 15px;text-align:left;font-weight:bold"
              >{{i18n_local.heatings| allCaps}}</span>
            </b-col>
          </b-row>
          <b-row class="custom" v-if="notEmpty(listing.techDet.heatings)">
            <b-col
              lg="6"
              class="text-left"
              v-for=" (heat,id) in listing.techDet.heatings"
              :key="id"
            >
              <md-list>
                <md-list-item>
                  <md-icon>{{getHeatingIcon(heat)}}</md-icon>
                  <div class="md-list-item-text">
                    <span>{{getHeating(heat) | capitalize}}</span>
                  </div>
                </md-list-item>
              </md-list>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row v-else class="data-loading-container">
        <div class="loader-rolling-local"></div>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { mapGetters } from "vuex";
const lists = require("@/lists.js");
export default {
  props: {
    listing: {
      type: Object,
      required: true
    }
  },
  data: function() {
    return {};
  },
  computed: {
    ...mapGetters("internationalizationModule", ["i18n_local"]),
    listingLoaded() {
      if (this.listing.techDet && Object.keys(this.listing.techDet).length > 0)
        return true;
      else return false;
    }
  },
  created() {},
  methods: {
    getHouseRule(value) {
      for (let suity of lists.suitableList) {
        if (suity.value == value) return suity.text;
      }
      return "";
    },
    notEmpty(content) {
      if (Array.isArray(content)) return content.length > 0;
      else if (content) return true;
      else return false;
    },
    getHeating(value) {
      var r;
      for (let item of lists.heatingsTypeList) {
        if (item.value == value) {
          r = this.i18n_local[item.value];
          !r ? (r = item.text) : void 0;
        }
      }
      return r;
    },
    getHeatingIcon(value) {
      if (value == "localGas") return "widgets";
      if (value == "localSolid") return "widgets";
      if (value == "stove") return "widgets";
      if (value == "fireplace") return "widgets";
      if (value == "electric") return "offline_bolt";
      if (value == "electricFloor") return "view_headline";
      if (value == "waterFloor") return "waves";
      if (value == "central") return "settings_input_composite";
      if (value == "centralGas") return "settings_input_composite";
      if (value == "conditioner") return "airplay";
      if (value == "ionHeating") return "dialpad";
      if (value == "groundHeating") return "landscape";
      if (value == "oilHeating") return "fingerprint";
      if (value == "combined") return "track_changes";
      if (value == "airSourceHeatPump") return "highlight";
    }
  },
  filters: {
    allCaps: function(value) {
      return value.toUpperCase();
    },
    capitalize: function(value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
    currency: value => {
      if (value == "eur") return "€";
      else if (value == "gbp") return "£";
      else return "$";
    }
  }
};
</script>
<style scoped>
@import "../../assets/styles/global.css";
@import "../../assets/styles/listing-preview.css";
</style>



// WEBPACK FOOTER //
// src/components/listingComponents/propertyTechnicalDetails.vue